'use client';

import React, { useEffect } from 'react';

import { SignUpActions } from './components/SignUpActions';

import { SignupPageNames } from '@/modules/activityTracker/constants';
import { useSignupTracking } from '@/modules/signup/hooks/useSignupTracking';

export default function Signup({ nonce }: { nonce: string }) {
  const { sendSignupViewEvent } = useSignupTracking();

  useEffect(() => {
    sendSignupViewEvent(SignupPageNames.Main);
  }, []);

  return <SignUpActions nonce={nonce} />;
}
